export function OctoberScorerIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 8h24v8c0 10-5 16-12 22-7-6-12-12-12-22z" />
      <path d="M12 16h24" />
      <path d="M18 24l4 4 8-8" />
    </svg>
  );
}
